// Side-effect import for one-off initializations
import 'Source/config';

import React from 'react';
import { createRoot } from 'react-dom/client';
import history from './history';
import App from './app';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App history={history} />);
